import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

const KhatianTable = () => {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetch("/land.json")
      .then((res) => res.json())
      .then((json) => {
        // Detect if it's pagewise structure
        if (json.pages) {
          const allItems = json.pages.flatMap((p) => p.items);
          setData(allItems);
          setFiltered(allItems);
        } else {
          const items = json.items || json;
          setData(items);
          setFiltered(items);
        }
      })
      .catch((err) => console.error("Error loading data:", err));
  }, []);

  const handleSearch = (e) => {
    const val = e.target.value.toLowerCase();
    setSearch(val);
    const filteredData = data.filter((item) =>
      (item.KHATIAN_NO?.toString().toLowerCase().includes(val) ||
        item.DAGS?.toString().toLowerCase().includes(val) ||
        item.OWNERS?.toString().toLowerCase().includes(val))
    );
    setFiltered(filteredData);
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    const sorted = [...filtered].sort((a, b) => {
      const aVal = a[field] || "";
      const bVal = b[field] || "";
      return order === "asc"
        ? aVal.toString().localeCompare(bVal.toString(), undefined, { numeric: true })
        : bVal.toString().localeCompare(aVal.toString(), undefined, { numeric: true });
    });
    setSortField(field);
    setSortOrder(order);
    setFiltered(sorted);
  };

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  return (
    <div className="container mt-4">
      <h3>📋 Khatian Record Table</h3>

      <input
        type="text"
        className="form-control my-3"
        placeholder="🔍 Search by Khatian No, Dag, or Owner..."
        value={search}
        onChange={handleSearch}
      />

      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th onClick={() => handleSort("KHATIAN_NO")} style={{ cursor: "pointer" }}>
              Khatian No {sortField === "KHATIAN_NO" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
            </th>
            <th onClick={() => handleSort("DAGS")} style={{ cursor: "pointer" }}>
              Dags {sortField === "DAGS" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
            </th>
            <th onClick={() => handleSort("TOTAL_LAND")} style={{ cursor: "pointer" }}>
              Land (dec) {sortField === "TOTAL_LAND" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
            </th>
            <th>Owners (Click row to view)</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((item, index) => (
            <tr key={index} onClick={() => handleRowClick(item)} style={{ cursor: "pointer" }}>
              <td>{item.KHATIAN_NO || "-"}</td>
              <td>{item.DAGS || "-"}</td>
              <td>{item.TOTAL_LAND || "-"}</td>
              <td style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {item.OWNERS ? item.OWNERS.substring(0, 50) + "..." : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Khatian No: {selectedItem?.KHATIAN_NO}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <>
              <p><strong>Dags:</strong> {selectedItem.DAGS || "N/A"}</p>
              <p><strong>Total Land:</strong> {selectedItem.TOTAL_LAND || "N/A"} decimals</p>
              <p><strong>Owners:</strong><br /> {selectedItem.OWNERS || "N/A"}</p>
              <p><strong>Guardians:</strong><br /> {selectedItem.GUARDIANS || "N/A"}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default KhatianTable;
